import * as React from 'react';
import { useField, useFormikContext, FieldConfig } from 'formik';

const { CheckBox } = require('@cvent/carina-checkbox');

const FormikCheckbox = ({ ...props }: FieldConfig) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    return (
        <div className='FormikCheckbox'>
            <CheckBox
                {...field}
                {...props}
                checked={field.value}
                onBlur={() => {}}
                onChange={() => {
                    setFieldValue(field.name, !field.value);
                    setFieldValue('date', null);
                }}
            >
                My dates are flexible
            </CheckBox>
        </div>
    );
};

export default FormikCheckbox;
